import { ContentId } from '../player-manager/types';

export interface PlayerManagerProps {
    playingContentId: ContentId | null;
    stopContent: (playingContentId: ContentId) => void;
}

export enum PlayerIframeActionType {
    PLAYER_CLOSED = 'player-closed',
}
